/** User-facing copy when Site / page features are blocked on Test Drive boards. */
export const TEST_DRIVE_SITE_PAGE_UNAVAILABLE_MSG =
  "Site and page features are not available on Swivu Test Drive boards.";

/** True only when the board row reports `is_sandbox` (Bryntum: `isSandbox`). */
export function isSandboxBoardRecord(
  board: { isSandbox?: boolean } | null | undefined,
): boolean {
  return board?.isSandbox === true;
}
